import clientConfigurationProvider from "../../../providers/clientConfigurationProvider";
import global from "global";

const siteRootRedirect = () => {
  global.location.assign(clientConfigurationProvider().siteRootPath);
};

export default siteRootRedirect;
